import { useLocalStorageState } from "hooks/useLocalStorageState";
import {
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  createContext,
  useCallback,
  useMemo,
} from "react";

type ScreenWidth = "full" | "fixed";
type ScreenWidthContext = {
  screenWidth: ScreenWidth;
  screenMaxWidth: string | undefined;
  setScreenWidth: Dispatch<SetStateAction<ScreenWidth>>;
  toggleScreenWidth: () => void;
};

export const screenWidthContext = createContext<ScreenWidthContext>({
  screenWidth: "fixed",
  screenMaxWidth: undefined,
  setScreenWidth: () => {},
  toggleScreenWidth: () => {},
});

export function ScreenWidthProvider(props: PropsWithChildren<unknown>) {
  const [screenWidth, setScreenWidth] = useLocalStorageState<ScreenWidth>("screenWidth", {
    defaultValue: "fixed",
  });

  const screenMaxWidth = useMemo(() => {
    return screenWidth === "fixed" ? "2000px" : undefined;
  }, [screenWidth]);

  const toggleScreenWidth = useCallback(() => {
    setScreenWidth(screenWidth === "fixed" ? "full" : "fixed");
  }, [screenWidth, setScreenWidth]);

  const value: ScreenWidthContext = useMemo(
    () => ({
      screenWidth,
      screenMaxWidth,
      setScreenWidth,
      toggleScreenWidth,
    }),
    [screenWidth, screenMaxWidth, setScreenWidth, toggleScreenWidth]
  );
  return <screenWidthContext.Provider value={value}>{props.children}</screenWidthContext.Provider>;
}
